import React from 'react'

export default function ComponentInput({ component, ...props }) {
  return React.createElement(component, props)
}
